import script from "./DTSChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./DTSChart.vue?vue&type=script&setup=true&lang=ts"

import "./DTSChart.vue?vue&type=style&index=0&id=79d8be6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d8be6b"]])

export default __exports__